<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('dealerWithdrawal.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('dealerWithdrawal.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{
            $t('dealerWithdrawal.withdrawal')
            }}
          </ts-button>
          <div class="ts-flex">
            <div class="ts-w-64">
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 250px;"
                class="inline-block"
              />
            </div>
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
            <!-- drawer filter date -->
            <a-drawer
              :title="$t('filter')"
              placement="right"
              :closable="false"
              :visible="visible"
              @close="visible = false"
              :zIndex="1020"
              width="300px"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <a-range-picker
                      format="DD-MM-YYYY"
                      :defaultValue="rangeDate"
                      :defaultPickerValue="rangeDate"
                      valueFormat="DD-MM-YYYY"
                      @change="dateRangeChange"
                    >
                      <template slot="renderExtraFooter"></template>
                    </a-range-picker>
                  </div>
                </div>
              </div>
            </a-drawer>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
					field: 'dealer.dealer_name'
				}"
      >
        <template v-slot="{ record }">
          <td>{{ record.tran_no }}</td>
          <td>{{ record.tran_date }}</td>
					<td>{{ record.transaction_type.tran_type }}</td>
          <td>
            <span
              :class="
                record.beginning_balance < 0
                  ? 'ts-text-red-600'
                  : 'ts-text-green-600'
              "
              class="ts-font-extrabold"
            >{{ record.beginning_balance }}</span>
          </td>
          
          <td>
            <span class="ts-font-extrabold ts-text-red-600">{{ '-' + record.amount }}</span>
          </td>
          <td>
            <span
              :class="
                record.ending_balance < 0
                  ? 'ts-text-red-600'
                  : 'ts-text-green-600'
              "
              class="ts-font-extrabold"
            >{{ record.ending_balance }}</span>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
    <!-- form create or update -->
    <a-modal
      :title="$t('dealerWithdrawal.withdrawal')"
      v-if="show_form"
      v-model="show_form"
      width="400px"
      :footer="null"
      :maskClosable="false"
      @cancel="cancel"
      :zIndex="1020"
    >
      <form-component @close="cancel" />
    </a-modal>
  </div>
</template>

<script>
import FormComponent from './form'
import moment from 'moment'
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'dealerWithdrawal',
  components: {
    FormComponent
  },
  data() {
    return {
      visible: false,
      loading: false,
      show_form: false,
      rangeDate: [moment().format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('accounting/dealerWithdrawal', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.accounting.dealerWithdrawal.search
      },
      set(newValue) {
        this.$store.commit('accounting/dealerWithdrawal/SET_SEARCH', newValue)
        this.$store.commit('accounting/dealerWithdrawal/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('dealerWithdrawal.tranNo') },
        { name: this.$t('dealerWithdrawal.tranDate') },
        { name: this.$t('dealerWithdrawal.transactionType') },
        { name: this.$t('dealerWithdrawal.beginningBalance') },
        { name: this.$t('dealerWithdrawal.amount') },
        { name: this.$t('dealerWithdrawal.endingBalance') }
        // { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    cancel() {
      this.show_form = false
    },
    addNew() {
      this.show_form = true
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('accounting/dealerWithdrawal/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit('accounting/dealerWithdrawal/SET_DATE_FROM', dateRange[0])
      this.$store.commit('accounting/dealerWithdrawal/SET_DATE_TO',dateRange[1])
      this.fetchData()
    }
	},
	watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>